import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { CookieBanner } from "@/components/site/CookieBanner";
import { captureAttribution } from "@/lib/attribution";

import Home from "@/pages/Home";
import Funnel from "@/pages/Funnel";
import Complete from "@/pages/Complete";
import { Contact, DebtOptions, Faqs, HowItWorks } from "@/pages/StaticPages";
import { CookiePolicy, PrivacyPolicy, Terms } from "@/pages/LegalPages";

import { AuthProvider } from "@/admin/AuthContext";
import { RequireAuth } from "@/admin/AdminShell";
import AdminLogin from "@/admin/Login";
import Dashboard from "@/admin/Dashboard";
import Leads from "@/admin/Leads";
import LeadDetail from "@/admin/LeadDetail";
import Callbacks from "@/admin/Callbacks";
import Analytics from "@/admin/Analytics";
import Settings from "@/admin/Settings";

const PublicLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
    <CookieBanner />
  </>
);

const ScrollTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

const pub = (el) => <PublicLayout>{el}</PublicLayout>;

function App() {
  useEffect(() => { captureAttribution(); }, []);
  return (
    <BrowserRouter>
      <ScrollTop />
      <Toaster position="top-right" richColors />
      <AuthProvider>
        <Routes>
          <Route path="/" element={pub(<Home />)} />
          <Route path="/check-my-options" element={pub(<Funnel />)} />
          <Route path="/assessment/complete" element={pub(<Complete />)} />
          <Route path="/how-it-works" element={pub(<HowItWorks />)} />
          <Route path="/debt-options" element={pub(<DebtOptions />)} />
          <Route path="/faqs" element={pub(<Faqs />)} />
          <Route path="/contact" element={pub(<Contact />)} />
          <Route path="/privacy-policy" element={pub(<PrivacyPolicy />)} />
          <Route path="/cookie-policy" element={pub(<CookiePolicy />)} />
          <Route path="/terms-and-conditions" element={pub(<Terms />)} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route element={<RequireAuth />}>
            <Route path="/admin" element={<Dashboard />} />
            <Route path="/admin/leads" element={<Leads />} />
            <Route path="/admin/leads/:id" element={<LeadDetail />} />
            <Route path="/admin/callbacks" element={<Callbacks />} />
          </Route>
          <Route element={<RequireAuth roles={["ADMIN", "SUPER_ADMIN"]} />}>
            <Route path="/admin/analytics" element={<Analytics />} />
          </Route>
          <Route element={<RequireAuth roles={["SUPER_ADMIN"]} />}>
            <Route path="/admin/settings" element={<Settings />} />
          </Route>

          <Route path="*" element={pub(
            <div className="px-5 py-24 text-center">
              <h1 className="font-display text-4xl font-extrabold text-forest">Page not found</h1>
              <a href="/" className="mt-6 inline-block font-bold text-terracotta underline">Back to homepage</a>
            </div>
          )} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
